import { Group, Stack, Text } from "@mantine/core";
import { getNextValue, handleGroupBlur } from "../utils/select";
import { CardCheckbox } from "./CardCheckbox";

interface Props {
  value?: string;
  data?: Array<{ value: string; label: string; description: string }>;
  error?: string;
  label?: string;
  allowDeselect?: boolean;
  onChange: (value?: string) => void;
  onBlur?: () => void;
}

export const CardSelect = ({
  data,
  value,
  onChange,
  error,
  label,
  allowDeselect,
  onBlur,
}: Props) => {
  return (
    <Stack gap="xs" onBlur={handleGroupBlur(onBlur)} w="100%">
      {label && (
        <Text size="sm" variant="strong">
          {label}
        </Text>
      )}
      <Stack gap="s1">
        <Group gap="s2" w="100%" grow>
          {data?.map(item => {
            const isActive = item.value === value;

            return (
              <CardCheckbox
                key={item.value}
                label={item.label}
                description={item.description}
                checked={isActive}
                error={error}
                onClick={() =>
                  onChange(getNextValue(item.value, { value, allowDeselect }))
                }
              />
            );
          })}
        </Group>
        {error && (
          <Text size="xs" c="red">
            {error}
          </Text>
        )}
      </Stack>
    </Stack>
  );
};
